import * as React from "react";
import Table from "../../../components/Table/Table";
import EditLanguage from "../../Editing/EditLanguage";
import { editActions } from "../../../actions/editActions";
import { Dimmer } from "semantic-ui-react";
import { mainActions } from "../../../actions/mainActions";

/**
 * All the following props are passed from parent component
 */
export type LanguagesTableProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;

  editActions: typeof editActions;
  mainActions: typeof mainActions;
  activeUser: Api.User | undefined;
  toggleModal: () => void;
};

type LanguagesTableState = {
  isModalOpen: boolean;
};

export class LanguagesTable extends React.Component<LanguagesTableProps, LanguagesTableState> {
  state = {
    isModalOpen: false
  };
  componentWillUnmount(): void {
    this.props.mainActions.setLastEditedObjectId(undefined);
  }
  render(): JSX.Element {
    const { columns, pdApi, isEditActive, toggleModal, mainState } = this.props;
    const { locales } = pdApi;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;
    let selectedColumns: State.Column[] = [];
    let rows: Api.Locale[] = [];

    rows = [...locales];

    selectedColumns = columns["Languages"];
    const startingPage = mainState.lastEditedObjectId
      ? (rows.findIndex(language => language.locale === mainState.lastEditedObjectId) / // tslint:disable-line: no-bitwise
          mainState.pageSize) >>
        0
      : 0;
    return (
      <div className="flex-1">
        <div className="flex-1">
          <Table
            startingPage={startingPage}
            rows={rows}
            columns={selectedColumns}
            isHidingTextActive={isShortenTextEnabled}
            handleRowSelection={this.props.editActions.select}
            isRowSelected={this.isEnumerationSelected}
            pageSize={pageSize}
          />
        </div>
        {isEditActive && (
          <Dimmer active={true} page={true}>
            <div className="edit-view" style={{ flex: editSize , width : editSize == 0.3 ? "500px" : "1000px" }}>
              <EditLanguage toggleModal={toggleModal} />
            </div>
          </Dimmer>
        )}
      </div>
    );
  }

  /*
   * Returns status if enumeration has been selected
   * @param {Api.AnyEnumeration} parameter
   * @returns {boolean}
   */
  private isEnumerationSelected = (locale: Api.Locale): boolean => {
    const editedObjectId = this.props.editedObjectId ?? this.props.mainState.lastEditedObjectId;
    if (editedObjectId && locale.locale === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

export default LanguagesTable;

